import { useCallback, useEffect, useRef, useState } from 'react'

export function useHorizontalCarousel(dependency?: unknown) {
	const scrollRef = useRef<HTMLDivElement>(null)
	const [canScrollPrev, setCanScrollPrev] = useState(false)
	const [canScrollNext, setCanScrollNext] = useState(false)

	const updateScrollState = useCallback(() => {
		const container = scrollRef.current

		if (!container) {
			return
		}

		setCanScrollPrev(container.scrollLeft > 0)
		setCanScrollNext(container.scrollLeft + container.clientWidth < container.scrollWidth - 1)
	}, [])

	useEffect(() => {
		const container = scrollRef.current

		if (!container) {
			return
		}

		updateScrollState()
		container.addEventListener('scroll', updateScrollState, { passive: true })
		window.addEventListener('resize', updateScrollState)

		return () => {
			container.removeEventListener('scroll', updateScrollState)
			window.removeEventListener('resize', updateScrollState)
		}
	}, [updateScrollState, dependency])

	const handleScroll = (direction: 'prev' | 'next') => {
		const container = scrollRef.current

		if (!container) {
			return
		}

		const scrollAmount = Math.max(container.clientWidth * 0.8, 320)
		container.scrollBy({
			left: direction === 'next' ? scrollAmount : -scrollAmount,
			behavior: 'smooth',
		})
	}

	return { scrollRef, canScrollPrev, canScrollNext, handleScroll }
}
